import * as React from "react";
import styled from "styled-components";
import * as S from "@styled";
import theme from "styled-theming";
import { ThemeType } from "shared/styles/theme";
import { InlineLoadSpinner } from "shared/components/PageLoadSpinner";
import { fetchProcessVersion } from "../actions/FetchActions";
import { ProcessVersion } from "../model/ProcessVersion";
import Time from "shared/Time";

const deploymentInformationTextColor = theme("mode", {
    [ThemeType.light]: S.Colors.white,
    [ThemeType.dark]: S.Colors.white
});

const StyledDeploymentInformation = styled(S.SmallText)`
    color: ${deploymentInformationTextColor};
`;

export const DeploymentInformation: React.FC<DeploymentInformationProps> = (props) => {
    const initialState: DeploymentInformationState = { loading: true, loadingFailed: false, processVersion: null };
    const [state, setState] = React.useState(initialState);

    React.useEffect(() => {
        let isMounted = true;
        const loadData = async () => {
            const processVersion: ProcessVersion = await fetchProcessVersion(props.agentGroup, props.processGuid);

            if (!isMounted) {
                return;
            }

            setState({
                loading: false,
                loadingFailed: !processVersion,
                processVersion: processVersion,
            });
        };
        loadData();

        return () => {
            isMounted = false;
        };
    }, []);

    if (state.loadingFailed) {
        return <p>{FRENDS.Localizations.Failed}</p>;
    }

    if (state.processVersion && !state.processVersion.hasDeploymentInformation) {
        return <p style={{ textAlign: "center" }}>{FRENDS.Localizations.DeploymentInformationUnavailable}</p>;
    }

    return (
        <div id="deployment-information-selector">
            {state.loading ? (
                <InlineLoadSpinner color={S.Colors.white} />
            ) : (
                <>
                    {props.versionString ? getRow(FRENDS.Localizations.Version, props.versionString) : null}
                    {getRow(FRENDS.Localizations.Deployer, state.processVersion?.deployerUsername)}
                    {getRow(FRENDS.Localizations.DeployedAt, state.processVersion?.dateTimeDeployed ? Time.toDetailedLocalTime(state.processVersion.dateTimeDeployed) : "")}
                    {state.processVersion?.deploymentDescription ? <p>{state.processVersion.deploymentDescription}</p> : null}
                </>
            )}
        </div>
    );
};

const getRow = (key: string, value: string | undefined) => {
    return (
        <>
            <StyledDeploymentInformation>{key}: {value || FRENDS.Localizations.Unknown}</StyledDeploymentInformation>
            <br />
        </>
    )
};

export interface DeploymentInformationProps {
    processGuid: string | undefined;
    agentGroup: string;
    versionString?: string;
}

interface DeploymentInformationState {
    loading: boolean;
    loadingFailed: boolean;
    processVersion: ProcessVersion | null;
}
